// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2Px3C","consentsList":"PatientConsents_consentsList__2uF30","consentsListEmpty":"PatientConsents_consentsListEmpty__36bze"};